import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantEmbeddableForm } from '../mutations/createParticipantEmbeddableForm.mutation';
import type {
  CreateParticipantEmbeddableFormMutation,
  CreateParticipantEmbeddableFormMutationVariables,
} from '../types';

export const useCreateParticipantEmbeddableFormMutation = (
  options?: MutationOptions<
    CreateParticipantEmbeddableFormMutation,
    CreateParticipantEmbeddableFormMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantEmbeddableForm), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
